var map = {
	"./canva.js": "d538",
	"./courses.js": "153d",
	"./grades.js": "d1a5",
	"./index.js": "b019",
	"./sectionsCanvas.js": "2ec6",
	"./system-validation.js": "8937",
	"./users.js": "2919"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65c4";